// extracted by mini-css-extract-plugin
export default {"root":"xAL4d_sSOvpSzhavrln0","label-sm":"KS0hmkvg_3QVCt8rwZdN","label-md":"FARCAkVkiytYqc9eesoR","label-lg":"WMrV_ki8wua6IBqx6Z5u"};